<template>
  <div class="create">
    <form-title>账号信息</form-title>
    <info-panel>
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="90px"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="广告标题"
              prop="advertisingTitle"
            >
              <el-input v-model="createForm.advertisingTitle" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item
              label="广告简介"
              prop="advertisingDesc"
            >
              <editor :html.sync="createForm.advertisingDesc" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="banner"
              prop="bannerPic"
            >
              <upload :file-list.sync="createForm.bannerPic" />
              <el-input
                v-show="false"
                v-model="createForm.bannerPic"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="关联课程"
              prop="courseId"
            >
              <el-select
                v-model="createForm.courseId"
                placeholder="请选择关联课程"
                filterable
                clearable
              >
                <el-option
                  v-for="course in courseList"
                  :key="course.id"
                  :label="course.courseName"
                  :value="course.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item
              label="内容"
              prop="advertisingContent"
            >
              <editor :html.sync="createForm.advertisingContent" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
    <el-row
      :gutter="20"
      class="submit"
    >
      <el-col class="btns">
        <el-button @click="cancel">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="submit"
        >
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axClient from '@/services';
import types from '@/config';
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
import upload from '@/components/common/upload/upload.vue';
import Editor from '@/components/common/editor.vue';

export default {
  name: 'AgencyEdit',
  components: {
    formTitle,
    infoPanel,
    upload,
    Editor,
  },
  data() {
    return {
      createForm: {
        id: '',
        advertisingTitle: '', // 广告标题
        advertisingDesc: '', // 广告简介
        advertisingContent: '', // 广告内容
        bannerPic: '', // banner图片
        rank: '1', // 排序值
        valid: types.ADVERTISING_VALID_ENABLE, // 是否有效
        courseId: '', // 关联课程
      },
      creatRules: {
        advertisingTitle: [
          { required: true, message: '请输入广告标题', trigger: 'blur' },
        ],
        bannerPic: [
          { required: true, message: '请上传广告图片', trigger: 'blur' },
        ],
        advertisingDesc: [
          { required: true, message: '请上输入广告简介', trigger: 'blur' },
        ],
      },
      result: {},
      courseList: [], // 课程列表
      isEditType: !!this.$route.params.id,
    };
  },

  mounted() {
    this.isEdit();
    this.getCourseList();
  },
  methods: {
    // 获取图片
    getFilePath(path) {
      this.createForm.bannerPic = path;
    },
    // get editor html
    getEditor(html) {
      this.createForm.advertisingContent = html;
    },
    // 取消
    cancel() {
      window.history.back();
    },
    // 提交
    async submit() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          if (this.createForm.courseId === '') {
            this.createForm.courseId = -1;
          }
          const data = await axClient.advertising.advertisingUpsert(this.createForm);
          if (data) {
            if (this.isEditType) {
              this.$message.success('编辑广告成功');
            } else {
              this.$message.success('新增广告成功');
            }
            this.$router.push({ name: 'AdvertisingList' });
          }
        }
      });
    },
    // 是否编辑信息
    async isEdit() {
      if (this.isEditType) {
        // 编辑
        this.result = await axClient.advertising.getInfo({ id: this.$route.params.id });
        const {
          advertisingTitle,
          advertisingDesc,
          advertisingContent,
          bannerPic,
          rank,
          courseId,
          valid,
          id,
        } = this.result;
        this.createForm = {
          advertisingTitle,
          advertisingDesc,
          advertisingContent,
          bannerPic,
          courseId,
          rank,
          id,
          valid,
        };
      }
    },
    // 查询课程列表
    async getCourseList() {
      this.courseList = await axClient.cert.listCourseNameByCert();
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  text-align: center;
  margin-top: 24px;
}
</style>